import React, { useEffect, useState } from "react";
import PostApiCall from "../../Api/Api";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { connect, useDispatch, useSelector } from "react-redux";

import { logout } from "../../Store/Actions/LoginAction";

import ManageAuditorAudit from "./ManageAuditorAudit";

import ManageApplicants from "./ManageApplicants";
import ManageApplication from "./ManageApplication";
import ProfileCard from "../../Components/ProfileCard";
import BreadCrumb from "../../Components/BreadCrumbComp";

import { AlignJustify, AlignRight, Eye } from "react-feather";
import { ProfileAction } from "../../Store/Actions/ProfileAction";

import UserVerification from "./UserVerification";
import Notiflix, { Notify } from "notiflix";

import ManageAudit from "./ManageAudit";
import classnames from "classnames";
import {
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Alert,
  Card,
} from "reactstrap";
import CommonModal from "../../Components/CommonModal";
import BasicProfileContent from "../../Components/BasicProfileContent";
import UserProfile from "../../Components/UserProfile";
import ReferalList from "./ReferalList";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import BankDetails from "../../Components/BankDetails";
import Payment from "./Payment";
import PaymentHistory from "./PaymentHistory";
import PaymentRequest from "./PaymentRequest";
import ManageAuditHistory from "./ManageAuditHistory";
const MyProfile = () => {
  const [page, setPage] = useState({ Page: "My Profile" });
  const location = useLocation();

  const tempUser = useSelector((state) => state.login);
  const [refresh, setRefresh] = useState(false);
  const { user } = useSelector((state) => state.profile);
  const dispatch = useDispatch();
  const [profileModal, setProfileModal] = useState(false);
  const [activeTab, setActiveTab] = useState(location?.state?.tab || 1);

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  const menuItems = [
    {
      name: "My Profile",
      key: 1,
      roles: ["Staff", "Seeker", "Auditor", "Recruiter"],
    },
    //  admin
    {
      name: "Manage Applicants",
      key: 2,
      roles: ["Staff", "Recruiter"],
    },
    //  seeker
    {
      name: "Manage Applications",
      key: 3,
      roles: ["Seeker", "Auditor"],
    },
    {
      name: "Manage Bank Details",
      key: 5,
      roles: ["Seeker"],
    },
    {
      name: "Referee list",
      key: 4,
      roles: ["Seeker", "Auditor"],
    },
   
    {
      name: `${(user?.fld_usertype !== "Staff" ||
        user?.fld_isadmin !== 1)?"Work History":"Manage Audit"}`,
      key: 8,
      roles: ["Staff", "Seeker", "Auditor", "Recruiter"],
    },
    // {
    //   name: "Payment History",
    //   key: 7,
    //   roles: ["Seeker", "Auditor"],
    // },
   
    
    {
      name: "Invoice Request",
      key: 9,
      roles: ["Staff", "Recruiter"],
    },
    {
      name: "Payment History",
      key: 10,
      roles: ["Staff", "Recruiter","Seeker", "Auditor"],
    },

    // {
    //   name: "Sign Out",
    //   key: 4,
    //   roles: ["Auditor", "Staff", "Seeker", "Recruiter"],
    // },
  ];

  const fetchProfileDetail = async () => {
    dispatch(ProfileAction.GetCountry());
    // Notiflix.Loading.init({ svgColor: "#c16d18" });
    Notiflix.Loading.standard();
    dispatch(ProfileAction.GetSeekerDetails());
    Notiflix.Loading.remove();
  };

  useEffect(() => {
    fetchProfileDetail();
  }, []);

  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (user) {
      if (user.fld_profileflag === 0) {
        setProfileModal(true); // Show the modal if the profile is incomplete
      }
    }
  }, [user]);

  return (
    <div className="" style={{ backgroundColor: "#f9fafb" }}>
      <div className="section marginLeftRight">
        <ToastContainer />
        <div className="mt-5">
          <div className="w-100">

          <BreadCrumb subitem={page.Page} icon={false} />
          </div>
  
         {/* {
          (tempUser?.fld_usertype !== "Staff" ||
            tempUser?.fld_isadmin !== 1) && <StepperComponent />
          } */}
            <Card
              className="border-0 mx-2"
              style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
            >
     
              <Row className="bg-white rounded-3">
                {/* Left Side Tab Menu */}
                <Col sm={12}  md={4}  xl={2}>
                  <Nav vertical pills className="mt-4">
                    {menuItems.map((item) => {
                      if (
                        item.roles.includes(
                          tempUser.fld_usertype ||
                            (tempUser?.fld_isadmin === 1 && "Staff")
                        )
                      )
                        return (
                          <NavItem key={item.key}>
                            <NavLink
                              style={{
                                color: "gray",
                                cursor: "pointer",
                                // border: "1px solid #dee2e6",
                                borderRadius: "4px",
                              }}
                              // style={{ color: "gray", cursor: "pointer" }}
                              className={classnames({
                                active: activeTab === item.key,
                                "nav-link": true,
                                "border-0": activeTab === item.key,
                              })}
                              onClick={() => toggleTab(item.key)}
                            >
                              {item.name}
                            </NavLink>
                          </NavItem>
                        );
                    })}
                  </Nav>
                </Col>

                {/* Right Side Content */}

                <Col sm={12} md={8} xl={10}>
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId={1}>
                      {user?.fld_verifydoc === null && (
                        <Alert color="warning" className="mt-4">
                          {" "}
                          To speed up your onboarding process, please complete your Profile !
                        </Alert>
                       )} 

                      <UserProfile userData={user} />
                      {/* <StepperComponent /> */}
                      {/* <StepperComponent/> */}
                    </TabPane>
                    <TabPane tabId={2}>
                      <div className="row">
                        <ManageApplicants />
                      </div>
                    </TabPane>
                    <TabPane tabId={3}>
                      {/* seeker */}
                      <ManageApplication />
                      {/* <ManageAudit/> */}
                    </TabPane>
                    <TabPane tabId={4}>
                      <ReferalList />
                    </TabPane>
                    <TabPane tabId={5}>
                      <BankDetails />
                    </TabPane>
                   
                    <TabPane tabId={8}>
                      <ManageAuditHistory />
                    </TabPane>
                    <TabPane tabId={9}>
                      <PaymentRequest />
                    </TabPane>
                    <TabPane tabId={10}>
                      <PaymentHistory />
                    </TabPane>
                  </TabContent>
                </Col>
              </Row>
            </Card>
       
        </div>
      </div>
      {profileModal && (
        <CommonModal
          isOpen={profileModal}
          toggle={() => console.log(false)}
          heading={`Basic Details`}
          modalSize={"lg"}
          contentBody={
            <BasicProfileContent
              userData={user}
              setProfileModal={setProfileModal}
            />
          }
          onConfirm={() => setProfileModal(false)}
          // confirmText={"Process"}
          // cancelText={"Cancel"}
          onCancel={() => setProfileModal(false)}
        />
      )}
    </div>
  );

 
};

export default MyProfile;
